<template>
    <header class="vheader">
        <div class="container">
            <div  class="vheader-logo-text" @click="redirect('/')">
                <a v-if="auth" href="/">
                    <img src="/images/sfinks_logo.svg" id="logo">
                </a>
            </div>
            <div v-if="showHeaderSearch" class="header-menu-item__search desktop">
				<input
                    type="text"
                    placeholder="ИНН, ОГРН, название или ФИО"
                    autocomplete="off"
                    v-model.trim="dadataSearchQuery"
                    @input="headerDadataSearch"
                    @keyup.esc="dadataSearchQuery = ''; dadataSeachCompanies = []"
                    id="header-menu-item__search-input"
                    class="header-menu-item__search-input"
                    >
				<div v-if="dadataSearchQuery || dadataSeachCompanies.length" @click="dadataSearchQuery = ''; dadataSeachCompanies = []" id="header-menu-item__search-suggestions-cross"></div>
				<!-- <div v-if="dadataSearchQuery" id="header-menu-item__search-suggestions-lupa"></div> -->
				<div v-if="dadataSeachCompanies.length" id="header-menu-item__search-suggestions">
                    <ul id="header-menu-item__search-suggestions-list">
                        <li v-for="(e,i) in dadataSeachCompanies" :key="i" class="header-menu-item__search-suggestions-list-item" @click="openCard(e.data.ogrn)">
                            <i v-if="e.data.state.status == 'ACTIVE'" class="uk-icon-check-circle" style="margin: 0 5px 0 0; color: #2ecc71"></i>
                            <i v-else-if="e.data.state.status == 'LIQUIDATING'" class="uk-icon-minus-circle" style="margin: 0 5px 0 0; color: #e7843c"></i>
                            <i v-else-if="e.data.state.status == 'LIQUIDATED'" class="uk-icon-times-circle" style="margin: 0 5px 0 0; color: #e74c3c"></i>
                            <i v-else-if="e.data.state.status == 'REORGANIZING'" class="uk-icon-check-circle" style="margin: 0 5px 0 0; color: #2ecc71"></i>
                            <i v-else-if="e.data.state.status == 'BANKRUPT'" class="uk-icon-check-circle" style="margin: 0 5px 0 0; color: #2ecc71"></i>
                            <span style="font-weight: 400">{{e.value}}</span>
                            <div v-if="e.data.management" style="font-size: 10px; line-height: normal; padding: 5px 0 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                <b class="header-menu-item__search-suggestions-list-item-post">{{e.data.management.post}}: </b>
                                <b class="header-menu-item__search-suggestions-list-item-post-icon"><i class="lnr lnr-user"></i></b>
                                <span style="padding-top: 5px;">{{e.data.management.name}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <div class="vheader-menu" v-if="userName"> -->
                <!-- <div
                    class="vheader-menu-item vheader-menu-item-monitoring"
                    @mouseover="showMonitoringMenu = true"
                    @mouseleave="showMonitoringMenu = false"
                    v-if="hasAccessToUlCheck || hasAccessToMonitoringFL"
                >
                    <span>Мониторинг</span>
                    <div v-if="showMonitoringMenu" class="vheader-menu-item-submenu">
                        <div v-if="hasAccessToUlCheck"><a href="/monitoring">Мониторинг ЮЛ/ИП</a></div>
                        <div v-if="hasAccessToMonitoringFL"><a href="/monitoring-fl">Мониторинг сотрудников</a></div>
                    </div>
                </div> -->
                <!-- <div class="vheader-menu-item vheader-menu-item-profile" @mouseover="showProfileMenu = true" @mouseleave="showProfileMenu = false">
                    <span class="lnr lnr-user"></span>
                    <span class="vheader-menu-item-profile__user-name">{{userName}}</span>
                    <div v-if="showProfileMenu" class="vheader-menu-item-submenu">
                        <div @click="redirect('/profile')"><a href="/profile">Профиль</a></div>
                        <div @click="redirect('/signout')"><a href="/signout">Выход</a></div>
                    </div>
                </div>
            </div>
            <div v-else @click="openSignin" class="vheader-menu-item vheader-menu-item-profile">Войти</div> -->
            <headerMenu />
        </div>
    </header>
</template>

<script>
import headerMenu from './headerMenu.vue'
import axios from 'axios'

export default {
    components: {
        headerMenu
    },
    data(){
        return {
            showMonitoringMenu: false,
            showProfileMenu: false,
            showBurgerMenu: false,
            origin: '',
            showHeaderSearch: false,
            dadataSearchQuery: '',
            dadataSeachCompanies: [],
            dadataTimerId: null
        }
    },
    methods: {
        openCard(ogrn) { window.open(`${window.location.origin}/company/${ogrn}`) },
        headerDadataSearch(){
            if(this.dadataTimerId) {
                clearInterval(this.dadataTimerId)
            }
            this.dadataTimerId = setTimeout(this.headerDadataRequest, 300)
        },
        headerDadataRequest() {
            if(this.dadataSearchQuery) {
                axios({
                    method: "POST",
                     url: "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party",
                    headers: {
                        Authorization: "Token c7e6720adc39e28edd06107e1d23e45fb6c27f8e"
                    },
                    data: {
                        query: this.dadataSearchQuery
                    }
                }).then(e => {
                    if (e?.data?.suggestions?.length) {
                        this.dadataSeachCompanies = e.data.suggestions.filter(elmnt =>  (elmnt.data?.inn?.[0] ? elmnt.data?.inn?.[0] : 0) + (elmnt.data?.inn?.[1] ? elmnt.data?.inn?.[1] : 0) != '99' )
                    }
                })
            } else {
                this.dadataSeachCompanies = []
            }
        },
        openMonitoring() {
            $("#screen-monitoring").show()
        },
        openSignin() {
            UIkit.modal("#modal-signin").show()
        }
    },
    computed: {
        auth(){
            return window.auth
        },
        userName(){ return this.$store.state.userName },
        hasAccessToMonitoringFL(){
            return this.$store.state.user.groups.filter(e => e.rules.monitoring_fl).length
        },
        hasAccessToUlCheck(){
            return this.$store.state.user.groups.filter(e => e.rules.check_ul || e.rules.adm_check_ul).length
        }
    },
    mounted(){
        this.origin = window.location.origin
        this.$store.dispatch('init')
        if(window.location.pathname.includes("/company/") || window.location.pathname.includes("/person/")) {
            this.showHeaderSearch = true
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/header"
@import "styles/global-variables.sass"

.vheader-menu-item-monitoring
    .vheader-menu-item-submenu
        width: 230px

#header-menu-item__search-input::placeholder
	font-style: italic
	color: #5e5e5e

.header-menu-item__search
    position: relative
    width: 525px
    margin: 0 10px
    line-height: $header-height
    background: transparent
    @media screen and (max-width: 960px)
        width: 300px
    @media screen and (max-width: 767px)
        width: 250px
    @media screen and (max-width: 480px)
        display: none

#header-menu-item__search-suggestions
    width: 100%
    text-align: left

#header-menu-item__search-input
    width: 100%
    border-radius: 8px
    padding-left: 8px
    border: 0
    height: 20px
    padding-right: 40px
    overflow: hidden
    text-overflow: ellipsis

#header-menu-item__search-suggestions-lupa:after
    content: "\e86f"

#header-menu-item__search-suggestions-lupa
    display: none
    font-family: 'Linearicons-Free'
    color: #333
    position: absolute
    right: 24px
    top: 2px
    font-size: 12px
    cursor: pointer

#header-menu-item__search-suggestions-cross:after
    content: "\e870"

#header-menu-item__search-suggestions-cross
    display: block
    font-family: 'Linearicons-Free'
    color: #333
    position: absolute
    right: 7px
    top: 1px
    font-size: 15px
    cursor: pointer

// #header-menu-item__search-suggestions 
//     width: 520px
//     position: absolute

#header-menu-item__search-suggestions-list
    padding: 0
    background-color: #fff
    color: #333
    border-right: 1px solid #496c93
    border-left: 1px solid #496c93
    border-bottom: 1px solid #496c93
    border-bottom-right-radius: 10px
    border-bottom-left-radius: 10px
    li
        cursor: pointer
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
        padding: 5px 20px
        font-size: 12px
        border-bottom: 1px solid #d4d4d4
        line-height: normal
        &:hover
            background-color: rgba(72, 115, 203, 0.2)
        &:last-child
            border: 0
    .header-menu-item__search-suggestions-list-item-post
        @media screen and (max-width: 767px)
            display: none
    .header-menu-item__search-suggestions-list-item-post-icon
        display: none
        @media screen and (max-width: 767px)
            display: inline-block


.vheader
    position: fixed
    z-index: 123
    top: 0
    left: 0
    width: 100%

.vheader-menu-item-profile
    .lnr.lnr-user
        display: none

@media screen and (max-width: $mobile-resolution)
    .vheader-menu-item-profile
        .lnr.lnr-user
            display: inline-block
        &__user-name
            display: none
    .vheader-menu-item
        padding: 0 15px
</style>